import React from 'react';
import Header from './Header';
import Section from './Section';
import { content } from 'data/content';
import * as S from './styles';

const Main: React.FC = () => {
  return (
    <S.Container>
      <Header />
      {content.map((section) => (
        <Section key={section.id} {...section} />
      ))}
      <S.Credits>
        Manicure: Chisato | Modelo: Luoyi (Premier Production)
      </S.Credits>
    </S.Container>
  );
};

export { Main };
